import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { TopicsSearchRemoveAction } from '../../domains/topicsSearch/actions.types';
import { TypeaheadAction } from '../../domains/typeahead/actions.types';

import { TopicsSearches } from './types';

export type TopicsSearchesAction = TypeaheadAction | TopicsSearchRemoveAction;

const initialState: TopicsSearches = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<TopicsSearches, TopicsSearchesAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'TYPEAHEAD.LOAD_PENDING':
      return action.payload.options.isSearchingFromTopicBrowsePage ? setPending() : state;
    case 'TYPEAHEAD.LOAD_FULFILLED':
      return action.payload.options.isSearchingFromTopicBrowsePage
        ? setFulfilled({ topicIds: action.payload.result.topics, searchText: action.payload.search })
        : state;
    case 'TYPEAHEAD.LOAD_REJECTED':
      return action.payload.options.isSearchingFromTopicBrowsePage ? setRejected(action.payload.error) : state;
    case 'TOPICS_SEARCH.QUERY_CLEARED':
      return initialState;
    default:
      return state;
  }
};

export default reducer;
